// extracted by mini-css-extract-plugin
var _1 = "fk4XNyvDOj";
var _2 = "RzVRtZXaiH";
export { _1 as "arrow", _2 as "root" }
